import React, { FC } from 'react'
import { SquarePen, UserRoundPlus } from 'lucide-react'

import customImageComponent from '../../../../../../../common/CustomImageComponent'

interface MissingTeamMemberProps {
  name?: string | null
  profilePicture?: string | null
  role: string
  description: string
  onEdit: () => void
}

export const MissingTeamMember: FC<MissingTeamMemberProps> = ({
  name,
  profilePicture,
  role,
  description,
  onEdit,
}) => {
  return (
    <div className="flex items-center gap-3 border-t-black/10 border-t py-4">
      <div className="w-[45px] h-[45px] border border-[#F2F2F2] rounded-md bg-[#F2F2F2] flex items-center justify-center overflow-hidden">
        {profilePicture || name ? (
          customImageComponent(profilePicture, name, 'w-full h-full object-cover')
        ) : (
          <UserRoundPlus className="w-5" />
        )}
      </div>
      <div>
        <h5 className="text-sm text-black font-semibold capitalize">{role}</h5>
        <p className="text-xs text-black/50 mt-1">{description}</p>
      </div>
      <div className="ml-auto">
        <button
          type="button"
          className="w-[30px] h-[30px] bg-[#F1F1F1] rounded-full flex items-center justify-center text-black hover:bg-SeabiscuitMainThemeColor/5  hover:text-SeabiscuitMainThemeColor active:bg-SeabiscuitMainThemeColor/10  active:text-SeabiscuitMainThemeColor transition-all"
          onClick={onEdit}
        >
          <SquarePen className="w-3" />
        </button>
      </div>
    </div>
  )
}
